export default {
	methods: {
		// Deze kan worden overschreven om het juiste formulier terug te geven
		canAny(permissions) {
			for (let permission of permissions) {
				if( this.$page.props.auth.permissions.includes(permission) ) {
					return true;
				}
			}
			return false;
		},
		can(permission) {
			return this.$page.props.auth.permissions.includes(permission);
		},
		cannot(permission) {
			return ! this.can(permission);
		},
		canAll(permissions) {
			let can = true;
			for (let permission of permissions) {
				can &= this.can(permission)
			}
			return can;
		}
	}
}
